let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("caxvA")).then(() => parcelRequire('6EYDg'));